import { render, staticRenderFns } from "./orgTabs.vue?vue&type=template&id=89db20f0&"
import script from "./orgTabs.vue?vue&type=script&lang=js&"
export * from "./orgTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports